"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBellOffFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 30a4.57 4.57 0 004.81-4h-9.62A4.51 4.51 0 0016 30z" }),
        React.createElement("path", { d: "M25 13.63V12.4a14.77 14.77 0 00-.2-2.4L30 4.81V2L2 30h2.82l6-6H29v-3.35l-.55-.28C26.29 19.28 25 16.76 25 13.63zM16 3c-5.72 0-9 3.39-9 9.29v1.23c0 3.15-1.32 5.78-3.45 6.86l-.55.27V24h1L22.64 5.36A9 9 0 0016 3z" }),
        React.createElement("path", { d: "M16 30a4.57 4.57 0 004.81-4h-9.62A4.51 4.51 0 0016 30z" })));
}
exports.default = SvgBellOffFilled;
//# sourceMappingURL=BellOffFilled.js.map